<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>

import { AUTH_SUCCESS, AUTH_LOGOUT } from './store/actions/auth'
import axios from 'axios'

export default {
  name: 'app',
  metaInfo: {
    title: 'Bizzoft',
    titleTemplate: '%s - Bizzoft'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  created: function () {
    if (this.$store.getters.isAuthenticated) {
      const token = this.$store.getters.getToken
      // console.log('ya esta autenticado')
      this.$store.dispatch(AUTH_SUCCESS, token)
    } /* else {
      this.$store.dispatch(AUTH_LOGOUT).then(() => { this.$router.push('/login') })
    } */ // Already handled before each router

    // if logout in one tab of the browser, this will trigger logout in the others if opened
    window.addEventListener('storage', this.syncLogout)

    axios.interceptors.response.use((response) => {
      return Promise.resolve(response)
    }, (error) => {
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        const httpStatus = error.response.status.toString()
        if (httpStatus.startsWith('4')) {
          console.debug('4xx error detected: ' + error.response.status)
          switch (error.response.status) {
            case 401: // Unauthorized
              if (this.$store.getters.isAuthenticated) {
                // this.toastWarn('Tu sesión y/o password y/o cuenta ha expirado, autenticate de nuevo')
                this.$store.dispatch(AUTH_LOGOUT).then(() => { this.$router.push('/login') })
                return new Promise(() => {})
              }
              error.response.data = { fieldErrors: [], globalErrors: [] }
              return Promise.reject(error)
            case 403: // Forbidden
              this.toastWarn('El recurso solicitado se encuentra protegido y el usuario no tiene privilegios de acceso suficientes')
              error.response.data = { fieldErrors: [], globalErrors: [] }
              return Promise.reject(error)
            case 400: // Bad Request
              return Promise.reject(error)
            case 409: // Conflict: payload holds context (e.g. duplicated persons), keep it intact
              return Promise.reject(error)
            case 422: // Unprocessable Entity
              this.toastError(error.response.data.message)
              error.response.data = { fieldErrors: [], globalErrors: [] }
              return Promise.reject(error)
            case 404: // Not Found
              this.toastWarn('El recurso o información solicitada no ha sido encontrada o no existe')
              error.response.data = { fieldErrors: [], globalErrors: [] }
              return Promise.reject(error)
            default:
              // Adding custom validation errors to prevent errors in components
              error.response.data = { fieldErrors: [], globalErrors: [] }
              return Promise.reject(error)
          }
        } else if (httpStatus.startsWith('5')) {
          console.debug('5xx error detected: ' + error.response.status)
          this.toastError('Ha ocurrido un error inesperado en el servidor, por favor intente más tarde, o bien, reporte a su administrador')
          // Adding custom validation errors to prevent errors in components
          error.response.data = { fieldErrors: [], globalErrors: [] }
          return Promise.reject(error)
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        this.toastError('Error local en la red: verifica que el dispositivo tiene una conexión activa a Internet')
        // Adding custom validation errors to prevent errors in components
        error.response = { data: { fieldErrors: [], globalErrors: [] } }
        return Promise.reject(error)
      } else {
        // Something happened in setting up the request that triggered an Error
        this.toastError('Ha ocurrido un error inesperado en el cliente, por favor intente más tarde, o bien, reporte a su administrador')
        // Adding custom validation errors to prevent errors in components
        error.response = { data: { fieldErrors: [], globalErrors: [] } }
        return Promise.reject(error)
      }
    })
  }
}
</script>
